<template>
  <ul class="flex items-center justify-center gap-2 m-0 p-0 list-none">
    <li>
        <button type="button" class="flex items-center justify-center p-1 text-white hover:bg-gradient-to-r hover:from-indigo-500 hover:to-purple-500 rounded-full transition-all touch-manipulation select-none active:scale-95" @click="emits('previous')">
          <BackwardIcon class="size-6 pointer-events-none" />
        </button>
    </li>
    <li class="">
      <button type="button" class="relative size-8 flex items-center justify-center p-1 text-white bg-gradient-to-r from-indigo-500 to-purple-500 rounded-full hover:bg-gradient-to-r hover:from-indigo-700 hover:to-purple-700 touch-manipulation select-none active:scale-95" 
      @click="emits('play')"
      :class="{ 'bg-gradient-to-r hover:from-indigo-500 hover:to-purple-500': props.isPaused }">
        <Transition>
          <PlayIcon v-if="props.isPaused" class="absolute left-[5px] size-6 transition-all pointer-events-none" />
        </Transition>
        <Transition>
          <PauseIcon v-if="!props.isPaused" class="absolute left-[4px] size-6 transition-all pointer-events-none" />
        </Transition>
      </button>
    </li>
    <li class="">
      <button type="button" class="flex items-center justify-center p-1 text-white hover:bg-gradient-to-r hover:from-indigo-500 hover:to-purple-500 rounded-full transition-all touch-manipulation select-none active:scale-95" @click="emits('next')">
        <ForwardIcon class="size-6 pointer-events-none" />
      </button>
    </li>
  </ul>
</template>

<script setup>
import { defineProps, defineEmits } from 'vue';
import { BackwardIcon, ForwardIcon, PlayIcon, PauseIcon } from '@heroicons/vue/24/outline';

const props = defineProps({
  isPaused: Boolean
});
const emits = defineEmits(['play', 'previous', 'next']);
</script> 